import { SearchEventsRefinementsLoadable } from '#/modules/search/events/components/Refinements/SearchEventsRefinementsLoadable';
import { SearchInternshipRefinementsLoadable } from '#/modules/search/internships/components/Refinements/SearchInternshipRefinementsLoadable';
import { SearchJobsRefinementsLoadable } from '#/modules/search/jobs/components/Refinements/SearchJobsRefinementsLoadable';
import { SearchOrgRefinementsLoadable } from '#/modules/search/orgs/components/Refinements/SearchOrgRefinementsLoadable';
import { SearchVolopsRefinementsLoadable } from '#/modules/search/volops/components/Refinements/SearchVolopsRefinementsLoadable';
import type { ListingType } from '#/types/ListingType';

type Args = {
  searchType: ListingType;
};

/**
 * TODO: get rid of this component
 *
 * This component causes issues with code splitting. Ideally we just reference
 * the component we want directly in a particular page.
 */
export function SearchRefinementsSwitch({ searchType }: Args) {
  switch (searchType) {
    case 'JOB':
      return <SearchJobsRefinementsLoadable />;
    case 'INTERNSHIP':
      return <SearchInternshipRefinementsLoadable />;
    case 'VOLOP':
      return <SearchVolopsRefinementsLoadable includeSourcesFacet={false} />;
    case 'ORG':
      return <SearchOrgRefinementsLoadable />;
    case 'EVENT':
      return <SearchEventsRefinementsLoadable />;
  }
}
